import LegalContentPage from './LegalContentPage';

export default function AgreementPage() {
  return <LegalContentPage type="agreement" />;
}
